import config from "config/appConfig";

import type { PaginationTokenType } from "shared/types";
import type { IStateProps } from "utils/StateOf";
import createStore from "utils/createStore";

import type { DataExportModel } from "../../types/DataExports";

const localStorageKey = `${config.GLOBAL_CONSTANTS.LOCAL_STORAGE_PREFIX}${config.HOOK_STORAGE_KEYS.DATA_EXPORTS_DATA}`;

export interface Values {
	loading: boolean;

	exporting: boolean;
	dataExports: DataExportModel[];
	nextToken: PaginationTokenType;
	previousToken: PaginationTokenType;

	submitting: boolean;
}

export const initialState: IStateProps<Values> = {
	loading: false,

	exporting: false,
	dataExports: [],
	nextToken: null,
	previousToken: null,

	submitting: false
};

export default createStore<Values>({
	initialState,
	persistant: true,
	persistantName: localStorageKey
});
